import { Modal, Button, Spinner} from 'react-bootstrap';
import { FiUserX } from 'react-icons/fi';
import { useMutation, useQueryClient } from 'react-query';
import { IOrg, IMembership } from '../../models/org';
import { deleteMember } from '../../api/org';
type Props = {
    orgId: string;
    member: IMembership;
    cancel: React.Dispatch<React.SetStateAction<IMembership | undefined>>;
    setError: React.Dispatch<React.SetStateAction<string | null>>
}

const ConfirmDeleteMember = ({orgId, member, cancel, setError} : Props) => {
    const handleClose = () => cancel(undefined);

    const queryClient = useQueryClient();
    const { mutateAsync: deleteMemberFn, isLoading} = useMutation( deleteMember, {
            onSuccess: () => {
                queryClient.invalidateQueries(['Memberships', orgId]);
                setError(null);
                handleClose();
            },
            onError: (error: any) => {
                setError(
                    "Unexpected error. Please try again or contact admin."
                );
                handleClose();
            },
        }
    );

    const handleDelete = async () => {
        deleteMemberFn({
            orgId,
            id: member.id
        });
    }

    return (
        <Modal show={!!orgId} onHide={handleClose} size='sm' centered>
            <Modal.Header closeButton className="bg-dark border-secondary">
                <Modal.Title className="text-white d-flex align-items-center">
                    <FiUserX className="me-2" size={20} />
                    Confirm Delete
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-dark text-white">
                <p className="text-white">
                    Are you sure you want to remove<br/> 
                    <strong className="text-danger">{member.email}</strong> from the organization?
                </p>
                <small className="text-light">This action cannot be undone.</small>
            </Modal.Body>
            <Modal.Footer className="bg-dark border-secondary">
                <Button variant="outline-light" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="danger" onClick={handleDelete} disabled={isLoading}>
                    {isLoading ? <Spinner size="sm" className="me-2" /> : <FiUserX className="me-2" />}
                    {isLoading ? "Removing..." : "Remove Member"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmDeleteMember;